module.exports = __webpack_public_path__ + "static/media/Checked.315a7fd7.PNG";